// extracted by mini-css-extract-plugin
export var label = "_ap-1";
export var reminder = "_ap-0";